/** Collection (Pro): filter/sort auto-submit, one open dropdown at a time, visible-only video playback. */
if (!customElements.get('collection-pro')) {
  class CollectionPro extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-filter-form]');

      this.form?.addEventListener('change', (event) => {
        const target = event.target;
        if (target.matches('input[type="checkbox"], select[name="sort_by"]')) this.submit();
      });

      this.querySelectorAll('[data-filter-dropdown]').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('[data-filter-dropdown][open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });

      this.onDocClick = (event) => {
        if (!event.target.closest('[data-filter-dropdown]')) {
          this.querySelectorAll('[data-filter-dropdown][open]').forEach((d) => (d.open = false));
        }
      };
      document.addEventListener('click', this.onDocClick);

      this.mq = window.matchMedia('(max-width: 749px)');
      this.onMq = () => this.playVisibleVideos();
      this.mq.addEventListener('change', this.onMq);
      this.playVisibleVideos();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      this.mq?.removeEventListener('change', this.onMq);
    }

    submit() {
      if (!this.form) return;
      // Drop empty price inputs so they don't create empty filters
      this.form.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value === '') input.disabled = true;
      });
      this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
    }

    playVisibleVideos() {
      this.querySelectorAll('[data-cpro-video-wrap] video').forEach((video) => {
        const visible = video.getClientRects().length > 0;
        if (visible) {
          video.preload = 'auto';
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          video.pause();
        }
      });
    }
  }

  customElements.define('collection-pro', CollectionPro);
}
